var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "mode search_criteria_dialog search_save",
      attrs: {
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "custom-class": "layout-dialog",
        title: _vm.title,
        top: "5vh",
        visible: _vm.show,
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.show = $event
        },
      },
    },
    [
      _c(
        "vab-form",
        {
          ref: "form",
          attrs: {
            "label-width": "78px",
            "label-position": "left",
            model: _vm.form,
            rules: _vm.rules,
          },
        },
        [
          _c("div", { staticClass: "flex_space flex_center_align" }, [
            _c(
              "div",
              { staticClass: "new_h_date flex_center_align" },
              [
                _c("svg-icon", {
                  staticClass: "new_h_date_svg",
                  attrs: { "icon-class": "tryangle_down" },
                }),
                _c("span", { staticClass: "ml2" }, [
                  _vm._v("最大10件まで登録できます"),
                ]),
              ],
              1
            ),
            _c("div", { staticClass: "nums" }, [
              _vm._v(" 登録済み件数 "),
              _c("span"),
              _vm._v(" " + _vm._s(_vm.list.length) + "件/10件 "),
            ]),
          ]),
          _c(
            "vab-row",
            [
              _c(
                "vab-col",
                { attrs: { span: 24 } },
                [
                  _c("vab-input", {
                    attrs: {
                      label: "検索条件名",
                      prop: "name",
                      maxlength: "50",
                    },
                  }),
                  _c("span", { staticClass: "word" }, [
                    _vm._v("最大50文字まで入力できます"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer flex_end",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "div",
            { staticClass: "flex_start flex_center_align" },
            [
              _c(
                "el-button",
                {
                  staticClass: "cancel",
                  on: {
                    click: function ($event) {
                      _vm.show = false
                    },
                  },
                },
                [_vm._v("キャンセル")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "sub_btn",
                  attrs: { type: "primary", disabled: _vm.isName },
                  on: {
                    click: function ($event) {
                      return _vm.confirm()
                    },
                  },
                },
                [
                  _c("svg-icon", {
                    staticClass: "sub_btn_svg",
                    class: _vm.isName ? "answer_disabled" : "answer",
                    attrs: { "icon-class": "check_line" },
                  }),
                  _vm._v(" 登録 "),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }